<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import { formatDateTime, splitAndCapitalize } from '@services/Helpers.js';
import { keyBy } from 'lodash';
import UserRepository from '@services/repositories/UserRepository';

export default {
    name: 'ActivityLogTable',
    components: {
        RednaxDatatable,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data: () => ({
        users: null,
    }),
    mounted() {
        this.getUsers();
    },
    methods: {
        splitAndCapitalize,
        formatDateTime,
        getEntity(log) {
            if (log.subject_type === 'App\\Models\\Prod') {
                return 'Produkt #' + log.subject.position;
            }
            if (log.subject_type === 'App\\Models\\ProdLager') {
                return 'Lager #' + log.subject_id;
            }
            if (log.subject_type === 'App\\Models\\ProdSupplier') {
                return 'Leverantör #' + this.id;
            }
            if (log.subject_type === 'App\\Models\\ProdPurchase') {
                return 'Inköp #' + this.id;
            }
            return splitAndCapitalize(log.subject_type) + ' #' + log.subject_id;
        },
        parseChanges(log) {
            let text = '';
            if (log.subject_type === 'App\\Models\\ProdLager' && log.event === 'created') {
                if (log.subject.Typ === 2) {
                    text = 'Manuell justering skapad';
                } else if (log.subject.Typ === 3) {
                    text = 'Inleverans';
                } else if (log.subject.Typ === 1) {
                    text = 'Beställning skapad';
                }
            } else if (log.event === 'created') {
                text = 'Skapad';
            } else if (log.event === 'updated') {
                text = 'Ändrade ';
                const arr = [];
                Object.entries(log.properties.attributes).forEach(([attr, newVal]) => {
                    if (newVal instanceof Object) {
                        arr.push(attr);
                    } else {
                        arr.push(attr + ' från ‘' + (log.properties.old && Object.hasOwn(log.properties.old, attr) ? log.properties.old[attr] : '') + '’ till ‘' + newVal + '’');
                    }
                });
                text += arr.join(', ') + '.';
            }
            return text;
        },
        async getUsers() {
            const client = new UserRepository();
            client.getAll().then((res) => {
                this.users = keyBy(res, 'id');
            });
        },
    },
    computed: {
        table_columns() {
            return [
                {
                    data: 'created_at',
                    header: 'Datum',
                    sortable: false,
                },
                {
                    data: 'entity',
                    header: 'Entitet',
                    sortable: false,
                },
                // {
                //     data: 'event',
                //     header: 'Event',
                //     sortable: false,
                // },
                {
                    data: 'causer_id',
                    header: 'Användare',
                    sortable: false,
                },
                {
                    data: 'properties',
                    header: 'Ändring',
                    sortable: false,
                },
            ];
        },
    },
};
</script>

<template>
    <rednax-datatable
        :columns="table_columns"
        url="/vue/activitylog"
        :filter="{ subject_type: this.type, subject_id: this.id }"
        sort-by="created_at"
        sort-order="created_at"
    >
        <slot/>
        <template #cell_properties="{ row }">
            {{ parseChanges(row) }}
        </template>
        <template #cell_causer_id="{ row }">
            {{ row.causer ? row.causer.name : '' }}
        </template>
        <template #cell_entity="{ row }">
            {{ getEntity(row) }}
        </template>
        <template #cell_created_at="{ row }">
            {{ formatDateTime(row.created_at) }}
        </template>
    </rednax-datatable>
</template>
